/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_OTHER } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsOtherFormState } from './contact-details-other-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-other-tab',
  templateUrl: 'contact-details-other-tab.component.html',
})
export class ContactDetailsOtherTabComponent {
  routes = [
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'other',
        contactType: CONTACT_TYPE_OTHER,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'other',
      },
    }),
  ];

  url: any;

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsOtherFormState,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('other');
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
